<!-- tieto 4 prvky su z dialogu rozvrhove-akcie-component.html -->
<button mat-icon-button class="close-button"
    [mat-dialog-close]="true">

  <!-- <span class="mat-mdc-button-persistent-ripple mdc-icon-button__ripple"></span> -->
  <mat-icon class="close-icon" color="warn">close</mat-icon>
</button>

<h2 mat-dialog-title class="text-black-50 fw-bold pt-2 mb-2">
  <span>{{titulok}}</span>
</h2>

<ng-container *ngIf="skratkyANazvyPredmetov; else jedenPredmet">
  <div *ngFor="let predmet of skratkyANazvyPredmetov; index as i">
    {{predmet[1]}} - {{predmet[0]}}
  </div>
</ng-container>
<ng-template #jedenPredmet>
  <h2
    class="d-none d-sm-block ms-4">
    {{predmetNazov}} <span class="text-black-50">{{predmetSkratka}}</span> <span class="ms-3 text-black-50">{{predmetRozsah}}</span>
  </h2>
</ng-template>



<!-- <h2 class="d-none d-sm-block ms-4">
  {{predmetNazov}} <span class="text-black-50">{{predmetSkratka}}</span> <span class="ms-3 text-black-50">{{predmetRozsah}}</span>
</h2>
<h2 class="d-none d-sm-block ms-4">
  {{predmetNazov}} <span class="text-black-50">{{predmetSkratka}}</span> <span class="ms-3 text-black-50">{{predmetRozsah}}</span>
</h2> -->

<div class="d-block d-sm-none">
  {{predmetSkratka}} - {{predmetNazov}}
  <span *ngIf="predmetRozsah" class="ms-3 text-black-50">{{predmetRozsah}}</span>
</div>

<hr/>

<!-- <p>dialog-header works! aaa</p> -->


